import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "store-details",
  class StoreDetails extends WYATTElement {
    constructor() {
      super();

      this.map = this.querySelector("[data-map]");

      this.setup();
    }

    async setup() {
      await this.loadDependencies();
      await this.initMap();
      await this.addMarker();
    }

    async loadDependencies() {
      const { Map } = await google.maps.importLibrary("maps");

      this.Map = Map;
      this.bounds = new google.maps.LatLngBounds();
    }

    async initMap() {
      this.map = new this.Map(this.map, {
        zoom: 15,
        center: this.config.location,
        mapId: this.config.id,
      });
    }

    async addMarker() {
      const { AdvancedMarkerElement } = await google.maps.importLibrary(
        "marker"
      );

      this.marker = new AdvancedMarkerElement({
        map: this.map,
        position: this.config.location,
        title: this.config.name,
        content: this.buildMarker(),
      });

      this.bounds.extend(this.config.location);
    }

    buildMarker() {
      const template = this.querySelector("[data-marker-template]");
      const content = template.content.firstElementChild?.cloneNode(true);

      return content;
    }
  }
);
